/* =============================================================================
   Glamlet Custom JS
   ============================================================================= */

/* Gender tabs (Women / Men / Kids) — switch the nav menu shown below */
(function () {
  var GENDERS = ['women', 'men', 'kids'];

  function genderFromHref(href) {
    if (!href) return null;
    var i = href.indexOf('#');
    if (i === -1) return null;
    var h = href.slice(i + 1).toLowerCase();
    return GENDERS.indexOf(h) !== -1 ? h : null;
  }

  function setActive(gender) {
    // panels (there may be several copies — normal + sticky header)
    document.querySelectorAll('[data-gender-panel]').forEach(function (panel) {
      var on = panel.getAttribute('data-gender-panel') === gender;
      panel.hidden = !on;
      panel.classList.toggle('is-active', on);
    });
    // tab links
    document.querySelectorAll('a[href*="#"]').forEach(function (a) {
      var g = genderFromHref(a.getAttribute('href'));
      if (!g) return;
      a.classList.add('gender-tab');
      a.classList.toggle('is-active', g === gender);
    });
    try { localStorage.setItem('glamlet_gender', gender); } catch (e) {}
  }

  // click handling via delegation (survives sticky header re-renders)
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a) return;
    var g = genderFromHref(a.getAttribute('href'));
    if (!g) return;
    e.preventDefault();
    setActive(g);
  });

  function init() {
    if (!document.querySelector('[data-gender-panel]')) return;
    var saved = null;
    try { saved = localStorage.getItem('glamlet_gender'); } catch (e) {}
    setActive(GENDERS.indexOf(saved) !== -1 ? saved : 'women');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* Glamlet — coupon validation message */
/* Ella applies the code with fetch('/discount/CODE') and throws the response away,
   so a wrong code fails silently until checkout. /cart.js reports
   discount_codes[].applicable, so poll it and tell the customer.
   The theme re-renders the drawer via Shopify.getCart right after the click, which
   wipes anything we insert — so re-assert on drawer changes, guarding against the
   observer re-triggering itself. */
(function () {
  var MSG_ID = 'glamlet-coupon-msg';
  var current = null;
  var writing = false;

  function render() {
    if (!current || writing) return;
    var scope = document.querySelector('coupon-code');
    if (!scope) return;
    var el = scope.querySelector('#' + MSG_ID);
    var cls = 'glamlet-coupon-msg is-' + current.state;
    if (el && el.textContent === current.text && el.className === cls) return; // already correct
    writing = true;
    try {
      if (!el) {
        el = document.createElement('p');
        el.id = MSG_ID;
        el.setAttribute('role', 'status');
        el.setAttribute('aria-live', 'polite');
        var btn = scope.querySelector('[data-update-coupon]');
        btn ? btn.insertAdjacentElement('afterend', el) : scope.appendChild(el);
      }
      el.textContent = current.text;
      el.className = cls;
    } finally {
      setTimeout(function () { writing = false; }, 0);
    }
  }
  function show(text, state) { current = { text: text, state: state }; render(); }

  var obs = new MutationObserver(function () { render(); });
  function watch() {
    var host = document.querySelector('.previewCart') || document.body;
    obs.observe(host, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();

  function check(code, tries) {
    fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hit = (cart.discount_codes || []).filter(function (d) {
          return (d.code || '').toLowerCase() === code.toLowerCase();
        })[0];
        if (!hit) {
          if (tries > 0) return setTimeout(function () { check(code, tries - 1); }, 400);
          return show('This code is not valid.', 'error');
        }
        if (hit.applicable) show('Discount applied.', 'ok');
        else show('This code is not valid or does not apply to the items in your cart.', 'error');
      })
      .catch(function () { show('Could not check the code. Please try again.', 'error'); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-update-coupon]');
    if (!btn) return;
    var scope = btn.closest('coupon-code') || document;
    var input = scope.querySelector('input[name="discount"]');
    var code = ((input && input.value) || '').trim();
    if (!code) { show('Enter a discount code.', 'error'); return; }
    show('Checking\u2026', 'pending');
    setTimeout(function () { check(code, 6); }, 600);
  });
})();
